module.exports = "/assets/logo_adobe-934ef06f5bbd6deed10dc4ae0ffd8bb3.png";